import React from 'react';

import { useKeyboardSurface } from '../../hooks/useSurface';

/**
 * A keycap chip. ⏎ · Space · ← →
 *
 * Renders ONLY at ≥1024 with a fine pointer. On a phone, or on a
 * touch-tablet at desktop width, a keycap hint is a lie — so it isn't
 * drawn at all, and (per the "hover is never load-bearing" rule) nothing
 * it labels is ever the only way to do the thing.
 */
export function Kbd({
  children,
  onAccent,
  style,
}: {
  children: React.ReactNode;
  /** Sitting on a coral button — invert for contrast. */
  onAccent?: boolean;
  style?: React.CSSProperties;
}) {
  const show = useKeyboardSurface();
  if (!show) return null;
  return (
    <kbd className={`wr-kbd ${onAccent ? 'on-accent' : ''}`.trim()} style={style} aria-hidden>
      {children}
    </kbd>
  );
}
